export default "__VITE_ASSET__CEhM6inI__"